import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "header",
  class: "ap-m-header"
}
const _hoisted_2 = {
  key: 1,
  class: "mx-1"
}
const _hoisted_3 = { class: "grow-auto d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-x" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, {
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
    name: _ctx.name,
    "content-style": { width: _ctx.widthCalc, height: 'auto' },
    class: "ap-modal-wrapper",
    "content-class": _ctx.contentClass,
    "click-to-close": _ctx.clickToClose,
    onBeforeOpen: _ctx.beforeOpen,
    onOpened: _ctx.opened
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.wrapper), {
        onSubmut: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('submit', $event)), ["stop"])),
        class: "modal-wrapper2"
      }, {
        default: _withCtx(() => [
          (_ctx.header)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.titleIcon)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: _normalizeClass(["ap-icon", _ctx.titleIcon])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (_ctx.titleIcon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.ParamsTitle), 1),
                (_ctx.showClose)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "close-btn",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                    }, _hoisted_5))
                  : _createCommentVNode("", true)
              ], 512))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "fixed-top"),
          _createElementVNode("div", {
            ref: "content",
            class: _normalizeClass(["ap-m-content", { 'no-padding': !_ctx.scollPadding }])
          }, [
            _createElementVNode("div", {
              class: "ap-m-content-inner",
              style: _normalizeStyle(_ctx.contentStyle)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4)
          ], 2),
          _renderSlot(_ctx.$slots, "after-main"),
          (_ctx.footer)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref: "footer",
                class: _normalizeClass(["ap-m-footer btn-group no-wrap", _ctx.footerClass])
              }, [
                _renderSlot(_ctx.$slots, "footer-before", { close: _ctx.onCancel }),
                (_ctx.cancelText)
                  ? (_openBlock(), _createBlock(_component_ap_button, {
                      key: 0,
                      title: _ctx.cancelText,
                      "btn-class": "btn-outline-primary",
                      onClick: _ctx.onCancel
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "footer", { close: _ctx.onCancel })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.hasAfterFooter)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "ap-m-footer-after",
                style: _normalizeStyle(_ctx.AfterFooterStyle)
              }, [
                _renderSlot(_ctx.$slots, "AfterFooter")
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 32))
    ]),
    _: 3
  }, 8, ["modelValue", "name", "content-style", "content-class", "click-to-close", "onBeforeOpen", "onOpened"]))
}